import type { QueryClient } from '@tanstack/react-query';
import type { NavigateFunction } from 'react-router-dom';
import { getPageURLWithSection, PageURL } from 'router/pageURL';
import { BtlApplicationFormPageEnum } from './types';

export const scrollBtlFormToTop = () => {
  const formElement = document.getElementById('form-scroll-container');
  if (formElement) {
    formElement.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

export async function invalidateBtlApplicationData(queryClient: QueryClient, applicationId: string) {
  await queryClient.invalidateQueries({ queryKey: ['btl-application-in-progress', applicationId] });
  await queryClient.refetchQueries({ queryKey: ['btl-application-in-progress', applicationId], type: 'active' });
  await queryClient.invalidateQueries({ queryKey: ['btl-missing-fields', applicationId] });
}

export function navigateToBtlCaseOverview(applicationId: string, navigate: NavigateFunction) {
  navigate(
    getPageURLWithSection(
      PageURL.BTL_APPLICATION_EDIT,
      { id: applicationId },
      { section: BtlApplicationFormPageEnum.CASE_SUMMARY },
    ),
  );
}

export function invalidateBtlApplicationDataAndNavigateToOverview(
  queryClient: QueryClient,
  applicationId: string,
  navigate: NavigateFunction,
) {
  invalidateBtlApplicationData(queryClient, applicationId);
  navigateToBtlCaseOverview(applicationId, navigate);
}
